import {
  INPUT_NAME_AGE_TO_BE,
  INPUT_NAME_KIDS_BIRTHDAY,
  INPUT_NAME_KIDS_NAME,
  INPUT_VALUE_COVER_TYPE_HARD,
  INPUT_VALUE_COVER_TYPE_SOFT,
} from '@shared/common/product';
import {
  BOOK_PRICE_FROEBELKAN,
  BOOK_PRICE_FROEBELKAN_HARD_COVER,
  INPUT_NAME_CHARACTERS,
  INPUT_NAME_KUN_CHAN,
  INPUT_VALUE_KUN_CHAN_NASHI,
  charactersFroebelkanArr,
  kunChanArr,
  KUNCHAN_VALUE_TO_LABEL_MAP,
} from '@shared/jp/product';
import {
  EBannerTextColor,
  PURPOSE_ADVENTURE,
  PURPOSE_BIRTH_GIFT,
} from '@shared/common/data/products';
import {
  getDateInputData,
  getSelectInputData,
  getSelectInputOptionData,
  getMultiselectInputData,
  getMultiselectInputOptionData,
  getTextInputData,
} from '@shared/common/data/inputs';
import {
  GET_BOOK_NAME_ERROR,
  getNameValidatorList,
} from '@shared/jp/data/inputs';
import { getPriceData } from '@shared/jp/data/products';
import type { IBookPreview } from '@shared/jp/data/products';
import { getFilledNumbersArray } from '@studiobuki/web-core/lib/timepicker-select';
import type { TCharactersF } from '@shared/jp/product';
import FroebelkanShared from '@shared/jp/vendors/froebelkan/data/products/books/FroebelkanShared';
import { getCoverHard, getCoverSoft } from './_utils';

// TODO: import from shared
export const MAKE_MAP =
  <K extends string, V = string>() =>
  <T extends { readonly [key in K]: V }>(o: T) =>
    o;

export const FroebelkanInputsKidsName = getTextInputData({
  label: '子どもの下の名前',
  placeholder: 'ひらがな６文字まで',
  name: INPUT_NAME_KIDS_NAME,
  validator: getNameValidatorList(6, 2),
  error: GET_BOOK_NAME_ERROR(6),
} as const);

export const FroebelkanInputsKunChan = getSelectInputData({
  label: 'くん・ちゃん付け',
  placeholder: '選んでください',
  options: kunChanArr.map((value) =>
    getSelectInputOptionData({
      label: KUNCHAN_VALUE_TO_LABEL_MAP[value],
      value,
    }),
  ),
  value: INPUT_VALUE_KUN_CHAN_NASHI,
  name: INPUT_NAME_KUN_CHAN,
} as const);

export const FroebelkanInputsKidsBirthday = getDateInputData({
  label: '生年月日',
  placeholder: 'yyyy/mm/dd',
  // value: new Date(),
  max: new Date(),
  name: INPUT_NAME_KIDS_BIRTHDAY,
} as const);

export const FroebelkanInputsAgeToBe = getSelectInputData({
  label: '何歳の誕生日？',
  placeholder: '1～6歳',
  options: getFilledNumbersArray(1, 6, 1).map((year) =>
    getSelectInputOptionData({ label: `${year}歳`, value: year }),
  ),
  // value: '',
  name: INPUT_NAME_AGE_TO_BE,
} as const);

const characterFroebelkanLabelMap = MAKE_MAP<TCharactersF>()({
  C01: 'アンパンマン',
  C02: 'しょくぱんまん',
  C03: 'カレーパンマン',
  C04: 'メロンパンナちゃん',
  C05: 'バタコさん',
  C06: 'めいけんチーズ',
} as const);

export const FroebelkanInputsCharacters = getMultiselectInputData({
  // label: 'LABEL',
  options: charactersFroebelkanArr.map((character) =>
    getMultiselectInputOptionData({
      imgSrc: `assets/images/f-characters/${character}.png`,
      label: characterFroebelkanLabelMap[character],
      value: character,
    }),
  ),
  name: INPUT_NAME_CHARACTERS,
  // set inside
  // min: 3,
  // max: 3,
});

const prices = {
  [INPUT_VALUE_COVER_TYPE_SOFT]: getPriceData(BOOK_PRICE_FROEBELKAN),
  [INPUT_VALUE_COVER_TYPE_HARD]: getPriceData(BOOK_PRICE_FROEBELKAN_HARD_COVER),
} as const;

const coverSoft = getCoverSoft({
  price: prices[INPUT_VALUE_COVER_TYPE_SOFT],
  carousel: [
    'assets/images/covers/froebelkan/SC01.jpg',
    'assets/images/covers/froebelkan/SC02.jpg',
    'assets/images/covers/froebelkan/SC03.jpg',
  ],
});
const coverHard = getCoverHard({
  price: prices[INPUT_VALUE_COVER_TYPE_HARD],
  carousel: [
    'assets/images/covers/froebelkan/HC01.jpg',
    'assets/images/covers/froebelkan/HC02.jpg',
    'assets/images/covers/froebelkan/HC03.jpg',
  ],
});

const Froebelkan: IBookPreview = {
  ...FroebelkanShared,
  caption: /* html */ `<span>アンパンマンバースデーブック`,
  summary:
    'お子さんのお誕生日をお祝いするためにアンパンマンやなかまたちがかけつけます。スペシャルパーティーの始まりです！',
  prices: [
    [INPUT_VALUE_COVER_TYPE_SOFT, prices[INPUT_VALUE_COVER_TYPE_SOFT]],
    [INPUT_VALUE_COVER_TYPE_HARD, prices[INPUT_VALUE_COVER_TYPE_HARD]],
  ],
  photos: [
    'assets/images/carousel01.jpg',
    'assets/images/carousel02.jpg',
    'assets/images/carousel03.jpg',
    'assets/images/carousel04.jpg',
    'assets/images/carousel05.jpg',
  ],
  menuPhoto: 'assets/images/f-sample.jpg',
  previewPhoto: 'assets/images/f-sample.jpg',
  // TODO
  properties: {
    purpose: [PURPOSE_ADVENTURE, PURPOSE_BIRTH_GIFT],
    age: {
      start: 0,
      end: 3,
    },
  },
  notice: {
    caption:
      '成長の記録や思い出の写真、メッセー ジとともにお子さま一人ひとりにパーソナライズされた絵本！',
    description:
      'みんなが大好きなアンパンマンやなかまたちがたくさん登\n場。スペシャルパーティーの始まりです！',
    points: [
      {
        imgSrc: 'assets/images/welcome-notice-point-1.png',
        caption: '1〜6歳におすすめ',
      },
      {
        imgSrc: 'assets/images/welcome-notice-point-2.png',
        caption: 'お誕生日プレゼントに',
      },
    ],
  },
  points: [
    {
      caption: 'どんなカスタムができるの？',
      description:
        '・主人公の名前を入れる<br>・表紙の色やリボンの色を選べる<br>・お子さんの成長記録（身長・体重）をいれる<br>・写真をいれる（５枚）<br> ・ケーキのロウソクの絵柄を選べる<br> ・メッセージをいれる（最大２か所）',
    },
    {
      caption: '絵本のストーリーは？',
      description:
        'アンパンマン、ばいきんまん、しょくぱんまん、メロンパンナちゃんなど人気のアンパンマンキャラクターが勢揃い。お子さんのバースデーパーティーの準備をします。<br>一生の思い出に残るバースデーパーティーの始まりです。',
    },
    {
      caption: 'ページ数や絵本の大きさは？',
      description:
        '全ての絵本は1冊ずつ、ご注文を受けてからオーダーメイドで印刷・製本されます。高級感のある、環境に配慮した用紙を使用しています。<br><br><b>・全28ページ<br>・21cm×21cm（本文部分）の正方形<br>・日本国内で製造</b>',
    },
  ],
  inputs: [
    FroebelkanInputsKidsName,
    FroebelkanInputsKunChan,
    FroebelkanInputsKidsBirthday,
    FroebelkanInputsAgeToBe,
  ],
  banner: {
    imgSrc: 'assets/images/bk3-banner-desktop-JP.jpg',
    imgSrcLtMd: 'assets/images/bk3-banner-mobile-JP.jpg',
    text: 'まいにちが　だいぼうけん。　ここにある　まほうを　みつけよう。',
    textColor: EBannerTextColor.dark,
  },
  description: [],
  review: {
    text: [
      'アンパンマンが大好きな娘へのプレゼントに。自分の写真を見て大興奮！いい思い出になりました。',
    ],
  },
  reviews: [],
  options: {
    [INPUT_VALUE_COVER_TYPE_HARD]: coverHard,
    [INPUT_VALUE_COVER_TYPE_SOFT]: coverSoft,
  },
  option: INPUT_VALUE_COVER_TYPE_SOFT,
  popularity: 15,
  createdAt: new Date('2020-01-03'),
};

export default Froebelkan;
